<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="main">
          <div class="filters">
            <b-button-group>
              <b-button
                class="buttons-filters"
                @click="analysisType = 'answer'"
                v-bind:class="{
                  active: analysisType === 'answer',
                }"
                >Resposta</b-button
              >
              <b-button
                class="buttons-filters"
                @click="analysisType = 'invite'"
                v-bind:class="{
                  active: analysisType === 'invite',
                }"
                >Convite</b-button
              >
            </b-button-group>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loader" class="row mb-4">
      <div class="col-12 text-center">
        <!-- <b-spinner
          variant="primary"
          type="grow"
          :label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner> -->
        <b-table style="font-size: 12px;" striped :fields="fields" :items="[0, 1, 2, 3]">
          <template v-slot:cell(corporateName) class="text-center">
            <idx-skeleton height="15" radius="10"></idx-skeleton>
          </template>
          <template v-slot:cell(lastDate) class="max-td text-center">
            <idx-skeleton width="55" height="15" radius="10"></idx-skeleton>
          </template>
          <template v-slot:cell(days) class="max-td text-center">
            <idx-skeleton width="55" height="15" radius="10"></idx-skeleton>
          </template>
        </b-table>
      </div>
    </div>

    <div v-else-if="this.items.length > 0">
      <div class="row mt-4">
        <div class="col-12">
          <b-table
            id="table-indicators"
            striped
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :fields="fields"
            :items="items"
            :per-page="perPage"
            :busy="loading"
            :current-page="currentPage"
            style="font-size: 12px;"
          >
            <template v-slot:cell(corporateName)="row">
              {{ row.item.corporateName }}
            </template>
            <template v-slot:cell(lastDate)="row" class="max-td">
              {{ formatDate(row.item.lastDate) }}
            </template>
            <template v-slot:cell(days)="row" class="max-td">
              {{ row.item.days }}
            </template>
          </b-table>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="mt-4 mb-4" style="font-size: 12px;">
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              aria-controls="table-indicators"
            ></b-pagination>
          </div>
        </div>
        <!-- <div class="col-6 mt-2 text-right">
          <a
            @click="exportToXLS"
            :title="`${this.$t('reports.exportXlsLabel')}`"
          >
            <span class="xls">
              <i class="fas fa-file-download"></i>
            </span>
          </a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import XLSX from 'xlsx';
import { lightFormat } from 'date-fns';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import Paginate from 'vuejs-paginate';
import api from '@/services/api';
import idxSkeleton from '@/components/molecules/idx-skeleton';

export default {
  name: 'SurveysInvitesPanels',
  components: {
    RadialProgressBar,
    animatedNumber,
    Paginate,
    idxSkeleton,
  },

  props: ['dataGraph'],

  data: () => ({
    analysisType: 'answer',
    loadingDownloadIconXls: false,
    userAuth: null,
    loader: false,
    loading: false,
    fields: [],
    sortBy: '',
    sortDesc: true,
    search: null,
    items: [],
    total: 0,
    currentPage: 1,
    perPage: 50,
    firstDisplayed: true,
    chartPromoters: '',
    chartPassives: '',
    chartDetrators: '',
    metricLabel: '',
    totalSteps: 100,
  }),
  methods: {
    async updateData() {
      this.loader = true;

      const response = await api.get(`reports/show-days`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          period: this.dataGraph.period,
          analysisType: this.analysisType,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
        },
      });

      this.selectIndicator(this.analysisType);

      this.items = response.data.data;
      this.total = response.data.total;

      this.loader = false;
    },

    async getIndicators() {
      this.indicatorSelected = null;
      this.indicatorLabels = [
        {
          value: null,
          text: this.$t('reports.indicators.selIndicatorSelectLabel'),
        },
      ];

      const response = await api.get(
        `indicators/distinct/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            period: this.dataGraph.period,
            actionId: this.dataGraph.actionId
              ? this.dataGraph.actionId._id
              : null,
            groupId: this.dataGraph.actionGroupId
              ? this.dataGraph.actionGroupId._id
              : null,
            metric: this.dataGraph.metric,
            ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          },
        },
      );

      response.data.indicators.forEach((indicator) => {
        this.indicatorLabels.push({
          value: indicator.key,
          text: indicator.text,
        });
      });
    },

    async selectIndicator(ev) {
      this.firstDisplayed = false;

      let label;
      if (ev) {
        if (ev === 'answer') {
          label = 'resposta';
        }
        if (ev === 'invite') {
          label = 'convite';
        }
      } else {
        if (this.analysisType === 'answer') {
          label = 'resposta';
        }
        if (this.analysisType === 'invite') {
          label = 'convite';
        }
      }

      this.fields = [
        {
          key: 'corporateName',
          label: 'Filial', // `${this.indicatorSelectedLabel}`,
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'lastDate',
          label: `Data ult. ${label}`,
          sortable: false,
          class: 'text-center max-td',
        },
        {
          key: 'days',
          label: `Dias sem ${label}`,
          sortable: false,
          class: ['text-center', 'max-td'],
        },
      ];
    },
    changeLabel() {
      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        this.chartPromoters = this.$t('reports.promoterLabel');
        this.chartPassives = this.$t('reports.neutralLabel');
        this.chartDetrators = this.$t('reports.detractorLabel');
        this.metricLabel = this.$t('reports.npsLabel');
        this.totalSteps = 100;
      } else if (this.dataGraph.metric.indexOf('ces') !== -1) {
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.metricLabel = this.$t('reports.cesLabel');
        this.totalSteps = 5;
      } else if (this.dataGraph.metric.indexOf('csat') !== -1) {
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.metricLabel = 'CSAT';
        this.totalSteps = 100;
      }
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    async exportToXLS() {
      const label = this.analysisType === 'answer' ? 'resposta' : 'convite';

      const response = await api.get(`reports/show-days`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          analysisType: this.analysisType,
          period: this.dataGraph.period,
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          metric: this.dataGraph.metric,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
        },
      });

      const items = response.data.data;

      const header = ['Filial'];

      const arr = [];
      items.forEach((a) => {
        arr.push({
          Filial: a.corporateName,
          [`Data ult. ${label}`]: this.formatDate(a.lastDate),
          [`Dias sem ${label}`]: a.days,
        });
      });

      const wb = XLSX.utils.book_new();

      wb.SheetNames.push('indicadores');

      const ws = XLSX.utils.json_to_sheet(arr, { header });

      wb.Sheets.indicadores = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', `monitoramento_${label}.xlsx`);
      document.body.appendChild(link);
      link.click();
    },
    async exportData(type) {
      // checks if the total docs to download is greater then 100k
      if (this.total > 100000) {
        swal({
          title: this.$t('scheduling.messages.maxDownloadError.title'),
          text: this.$t('scheduling.messages.maxDownloadError.description'),
          icon: 'warning',
        });
        return;
      }
      if (type === 'xlsx') {
        this.loadingDownloadIconXls = true;
      } else {
        this.loadingDownloadIconCsv = true;
      }

      try {
        await api.post(`reports/download/${this.userAuth.companyId}/${type}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            period: this.dataGraph.period,
            analysisType: this.analysisType,
            actionId: this.dataGraph.actionId
              ? this.dataGraph.actionId._id
              : null,
            ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
            // ih2: this.myIh2 === '0' ? null : this.myIh2,
            metric: this.dataGraph.metric ? this.dataGraph.metric : null,
            groupId: this.dataGraph.actionGroupId
              ? this.dataGraph.actionGroupId._id
              : null,
          },
        });

        swal({
          title: this.$t('answers.donwload.title'),
          text: this.$t('answers.donwload.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('answers.ops'),
          text: error.response.data.message,
          icon: 'error',
        });
      }

      if (type === 'xlsx') {
        this.loadingDownloadIconXls = false;
      } else {
        this.loadingDownloadIconCsv = false;
      }
    },
    formatDate(actionDate) {
      return lightFormat(new Date(actionDate), 'dd/MM/yyyy');
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.changeLabel();
    this.fields = [
      {
        key: 'corporateName',
        label: 'Filial',
        sortable: true,
        class: 'text-left',
      },
      {
        key: 'lastDate',
        label: 'Data ult. resposta/convite',
        sortable: false,
        class: 'text-center max-td',
      },
      {
        key: 'days',
        label: 'Dias sem resposta/convite',
        sortable: false,
        class: ['text-center', 'max-td'],
      },
    ];
    this.indicatorLabels = [
      {
        value: null,
        text: this.$t('reports.indicators.selIndicatorSelectLabel'),
      },
    ];
    await this.updateData();
  },

  async mounted() {
    await this.getIndicators();
  },
  watch: {
    analysisType: async function watchAnalysisType() {
      this.updateData();
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.main {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.filters {
  background: #f0f6fb;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 20px;
  margin-top: 12px;
}

.buttons-filters {
  background: #f0f6fb;
  border-radius: 50rem;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  outline: none;
  font-size: 12px;
}

.buttons-filters.active {
  background: #fff !important;
  border-radius: 50rem !important;
  padding-left: 15px !important ;
  padding-right: 15px !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: bold !important;
}

.cards {
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: none;
  position: relative;
  height: 65px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;

  transition: color 0.2s;

  &:hover {
    color: #1dc86e;
  }
}

.pagination-area-config-users >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>
<style>
.pagination-area-config-users .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-config-users a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/surveys-invites/panels/surveys-invites.vue